import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";
//

//namespace SlotGames {

export class IceBlast_1Screen extends SlotGameType1_1Screen {


    
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "IceBlast");

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }

    // protected PrepareFonts(resourceManager: ResourceManager): void {

    //     resourceManager.Add(new FontResource(this.basepath + "resources/Melting Letter.ttf", this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));

    // }

    //SEND COLOR FOR RSA 
    protected override color: RewardColor =
        {
            color: "#0A7CBF",
            coloroutherStroke: "black",
            colorinnerStroke: "#031333",
        }

}


